export default () => {
  const $ = document.querySelector.bind(document)
  const showEl = $('#sticky-show')
  const hideEl = $('footer')
  const stickyEl = $('#sticky-bar')

  if (!stickyEl) return;

  const watchEl = (el1, el2, cb) => {
    let ve = 0, he = 0, init = false;
    const els = [el1, el2]
    const IO = new IntersectionObserver((ObserverEntry) => {
      ObserverEntry.forEach(entry => {
        const { isIntersecting, target } = entry
        if(init) {
          if(isIntersecting) {
            cb(false)
          } else {
            cb(true)
          }
        }else {
          if(isIntersecting) { he++; }
          else {
            if(!he && els.includes(target)){
              ve++;
              if(ve === 2) {
                init = true
                const { top } = el1.getBoundingClientRect()
                if(top < window.innerHeight) cb && cb(true);
              }
            }else init = true
          }
        }
      })
    }, {
      rootMargin: '0px',
      threshold: 0
    })

    el1 && IO.observe(el1)
    el2 && IO.observe(el2)
  }

  watchEl(showEl, hideEl, (sh) => {
    const action = sh ? 'add' : 'remove';
    stickyEl.classList[action]('sb--show');
    document.querySelector('#chat-button')?.classList[action]('product-gorgias-chat-container');
  });
}